import React, { useEffect } from 'react';
import { Nullable } from 'src/types/nullable.type';
import { apiGetJourneyByAlias } from 'src/utils/journeyApi';
import { usePlayerStore } from './player-store';
import { useApplyThemeAtRoot } from '../helpers/themes/apply-theme-at-root.hook';
import { NeuePlayerAccessControlAndTracking } from './access-control-and-tracking';
import { Journey } from 'src/common/interfaces/journey.interface';
import { MemoizedNeuePlayerJourneyView } from './journey-view';
import { useCurrentUser } from 'src/store/user';

type Props = {
  uuid: string;
  stepPath?: Nullable<string>;
  token: string;
  previewMode?: boolean;
  pdfPreview?: boolean;
  bypass?: Nullable<string>;
  trackingUUID: Nullable<string>;
};

export const NeuePlayer = ({ uuid, stepPath, previewMode = false, pdfPreview = false, bypass = null, token, trackingUUID }: Props) => {
  const [journey, setJourney] = React.useState<Nullable<Journey>>(null);
  const themeSettings = usePlayerStore((state) => state.themeSettings);
  const currentUser = useCurrentUser((state) => state.currentUser);
  const setOrgData = usePlayerStore((state) => state.setOrgData);
  const setJourneyData = usePlayerStore((state) => state.setJourneyData);

  useApplyThemeAtRoot(themeSettings);

  useEffect(() => {
    if (!uuid) return;
    const fetchJourney = async () => {
      const journey = await apiGetJourneyByAlias(uuid, { neue: 1 });
      setJourney(journey);
      setJourneyData(journey.alias.slug);
    };

    if (uuid) {
      fetchJourney();
    }

    return () => {
      setJourney(null);
    };
  }, [uuid]);

  useEffect(() => {
    if (journey) {
      setOrgData(journey.organization.slug, journey.creator.uuid === currentUser?.uuid);
    }
  }, [currentUser, journey]);

  return (
    <NeuePlayerAccessControlAndTracking
      uuid={uuid}
      token={token}
      previewMode={previewMode}
      pdfPreview={pdfPreview}
      bypass={bypass}
      trackingUUID={trackingUUID}
      journey={journey}
    >
      <MemoizedNeuePlayerJourneyView 
        journey={journey} 
        stepPath={stepPath} 
        artificialDelay={1500} 
        previewMode={previewMode}
        pdfPreview={pdfPreview}
      />
    </NeuePlayerAccessControlAndTracking>
  );
};
